/* eslint-disable import/prefer-default-export */
import t from "./translator";

export function tData(device, attribute, key) {
  return key ? t(`msizer.data.${device}.${attribute}.${key?.toLowerCase()}`) : "";
}
